import { Star } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { BUSINESS } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-sand">
      <div className="mx-auto max-w-[1400px] px-6 py-12 lg:px-12 lg:py-16">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
          <div className="md:col-span-6">
            <p className="font-serif text-3xl tracking-tighter sm:text-4xl">
              STAR AVG <em className="text-terra">ENTERPRISE</em>
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-taupe">
              Interior design, modular furniture and turnkey execution — Greater
              Noida, Uttar Pradesh.
            </p>
            <a
              href={BUSINESS.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-google-rating"
              className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-taupe transition-colors duration-300 hover:text-ink"
            >
              <Star size={12} className="text-clay" fill="currentColor" strokeWidth={0} />
              {BUSINESS.rating} · {BUSINESS.reviewCount} Google reviews
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="mb-6 text-[11px] font-semibold uppercase tracking-[0.3em] text-taupe">Explore</p>
            <ul className="space-y-3 text-sm">
              {["Services", "Studio", "Gallery", "Reviews", "Contact"].map((l) => (
                <li key={l}>
                  {l === "Gallery" ? (
                    <a
                      href={BUSINESS.photosLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="footer-link-gallery"
                      className="transition-colors duration-300 hover:text-clay"
                    >
                      {l}
                    </a>
                  ) : (
                    <a
                      href={`#${l.toLowerCase()}`}
                      onClick={(e) => { e.preventDefault(); scrollToId(`#${l.toLowerCase()}`); }}
                      data-testid={`footer-link-${l.toLowerCase()}`}
                      className="transition-colors duration-300 hover:text-clay"
                    >
                      {l}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="mb-6 text-[11px] font-semibold uppercase tracking-[0.3em] text-taupe">Visit</p>
            <p className="text-sm leading-relaxed text-taupe">{BUSINESS.address}</p>
            <div className="mt-4 flex flex-col gap-1.5">
              <a
                href={BUSINESS.phoneHref}
                data-testid="footer-phone-link"
                className="text-sm transition-colors duration-300 hover:text-clay"
              >
                {BUSINESS.phone}
              </a>
              <a
                href="tel:+919582997025"
                data-testid="footer-phone-link-2"
                className="text-sm transition-colors duration-300 hover:text-clay"
              >
                +91 95829 97025
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-4 border-t border-line pt-8 text-[11px] uppercase tracking-[0.25em] text-taupe sm:flex-row sm:items-center sm:justify-between lg:mt-20">
          <span>© 2026 {BUSINESS.name}</span>
          <span>Designed & built in Greater Noida</span>
        </div>
      </div>
    </footer>
  );
}
